function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 6.5,
  y: 1.5,
  width: 14,
  height: 5,
  rx: 0.5,
  stroke: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 4.5C8.22386 4.5 8 4.27614 8 4C8 3.72386 8.22386 3.5 8.5 3.5H14.5C14.7761 3.5 15 3.72386 15 4C15 4.27614 14.7761 4.5 14.5 4.5H8.5Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19 4C19 4.27614 18.7761 4.5 18.5 4.5C18.2239 4.5 18 4.27614 18 4C18 3.72386 18.2239 3.5 18.5 3.5C18.7761 3.5 19 3.72386 19 4Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 4.5C16.7761 4.5 17 4.27614 17 4C17 3.72386 16.7761 3.5 16.5 3.5C16.2239 3.5 16 3.72386 16 4C16 4.27614 16.2239 4.5 16.5 4.5Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 6.5,
  y: 17.5,
  width: 14,
  height: 5,
  rx: 0.5,
  stroke: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 20.5C8.22386 20.5 8 20.2761 8 20C8 19.7239 8.22386 19.5 8.5 19.5H14.5C14.7761 19.5 15 19.7239 15 20C15 20.2761 14.7761 20.5 14.5 20.5H8.5Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M19 20C19 20.2761 18.7761 20.5 18.5 20.5C18.2239 20.5 18 20.2761 18 20C18 19.7239 18.2239 19.5 18.5 19.5C18.7761 19.5 19 19.7239 19 20Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 20.5C16.7761 20.5 17 20.2761 17 20C17 19.7239 16.7761 19.5 16.5 19.5C16.2239 19.5 16 19.7239 16 20C16 20.2761 16.2239 20.5 16.5 20.5Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 8.5,
  y: 9.5,
  width: 14,
  height: 5,
  rx: 0.5,
  stroke: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 12.5C10.2239 12.5 10 12.2761 10 12C10 11.7239 10.2239 11.5 10.5 11.5H16.5C16.7761 11.5 17 11.7239 17 12C17 12.2761 16.7761 12.5 16.5 12.5H10.5Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M21 12C21 12.2761 20.7761 12.5 20.5 12.5C20.2239 12.5 20 12.2761 20 12C20 11.7239 20.2239 11.5 20.5 11.5C20.7761 11.5 21 11.7239 21 12Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 12.5C18.7761 12.5 19 12.2761 19 12C19 11.7239 18.7761 11.5 18.5 11.5C18.2239 11.5 18 11.7239 18 12C18 12.2761 18.2239 12.5 18.5 12.5Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 6.5V9.5M14.5 14.5V17.5",
  stroke: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M6 4L6.35355 4.35355L6.70711 4L6.35355 3.64645L6 4ZM4.35355 1.64645C4.15829 1.45118 3.84171 1.45118 3.64645 1.64645C3.45118 1.84171 3.45118 2.15829 3.64645 2.35355L4.35355 1.64645ZM3.64645 5.64645C3.45118 5.84171 3.45118 6.15829 3.64645 6.35355C3.84171 6.54882 4.15829 6.54882 4.35355 6.35355L3.64645 5.64645ZM6.5 19.5H3V20.5H6.5V19.5ZM2.5 19V5H1.5V19H2.5ZM3 4.5H6V3.5H3V4.5ZM6.35355 3.64645L4.35355 1.64645L3.64645 2.35355L5.64645 4.35355L6.35355 3.64645ZM5.64645 3.64645L3.64645 5.64645L4.35355 6.35355L6.35355 4.35355L5.64645 3.64645ZM2.5 5C2.5 4.72386 2.72386 4.5 3 4.5V3.5C2.17157 3.5 1.5 4.17157 1.5 5H2.5ZM3 19.5C2.72386 19.5 2.5 19.2761 2.5 19H1.5C1.5 19.8284 2.17157 20.5 3 20.5V19.5Z",
  fill: "white"
});

var SvgProductivityIssues = function SvgProductivityIssues(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProductivityIssues, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/productivity-issues.7025bfdd.svg";
export { ForwardRef as ReactComponent };